import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatCompareData = (pointWxData, now, japanClothData = {}, localTimezone = null) => {
  const timezone = pointWxData.timezone
  // 服装データが無い場合は calcClothTemp に空配列(srf)を渡す。比較対象の SS1 データには
  // srf(時間別)が無いが、srf が取れない日は mrf の maxt/mint から推定する経路に乗るため、
  // 空アイコン(tops_null)にならない(srf があれば実況値を優先)。
  const mrf = (japanClothData && japanClothData?.Result && japanClothData?.Result?.clothes)
    ? pointWxData.mrf.map((item) => {
      const clothInfo = japanClothData.Result.clothes.find((cloth) => cloth.tm === item.utm)
      return {
        ...item,
        daytimeClothRank: clothInfo?.rank?.daytime,
        nighttimeClothRank: clothInfo?.rank?.morning_night
      }
    })
    : calcClothTemp(pointWxData.srf ?? [], pointWxData.mrf, timezone)
  return formatDaily(mrf, now, timezone, localTimezone)
}

/**
 *
 * @param {Object[]} mrf
 * @param {number} now
 * @param {string} timezone
 * @returns {Object[]}
 */
const formatDaily = (mrf, now, timezone, pointTimezone = null) => {
  if (pointTimezone !== null) {
    const nowInPointTz = dayjs.unix(now).tz(pointTimezone)
    const startOfTodayInPointTz = nowInPointTz.startOf('day')

    const res = []
    for (let day = 0; day < 7; day++) {
      const currentDay = startOfTodayInPointTz.tz(pointTimezone).add(day, 'day')
      const dayData = mrf.find((item) => {
        const itemDay = dayjs.unix(item.utm).tz(timezone).startOf('day')
        // dayjsでの比較で同じ日に判定されないことがあったので、文字列で比較
        // return itemDay.isSame(currentDay, 'day')
        return itemDay.format('M/D') === currentDay.format('M/D')
      })
      if (dayData) {
        const tm = dayjs.unix(dayData.utm).tz(timezone)
        const isHourlyTz = tm.minute() === 0
        const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
        res.push({
          ...dayData,
          past: modifiedTm.startOf('day').unix() < nowInPointTz.startOf('day').unix(),
          date: modifiedTm.format('M/D'),
          fullDate: modifiedTm.locale(ja).format('M月D日(ddd)')
        })
      } else {
        res.push({ past: false })
      }
    }
    return res
  }

  const nowInTz = dayjs.unix(now).tz(timezone)
  const res = mrf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('day').unix() < nowInTz.startOf('day').unix()
      return {
        ...item,
        past: isPast,
        date: modifiedTm.format('M/D'),
        fullDate: modifiedTm.locale(ja).format('M月D日(ddd)')
      }
    })
    .filter((item) => !item.past)
    .filter((_, index) => index < 7)
  return res
}
